import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'
import { Swiper, Slide } from 'react-dynamic-swiper'
import { Link } from 'gatsby'
import 'react-dynamic-swiper/lib/styles.css'
import styles from './FeaturesCaroussel.module.css'

const query = graphql`
  query {
    allFile(filter: { relativePath: { regex: "/features/" } }) {
      nodes {
        relativePath
        childImageSharp {
          fluid(quality: 90, maxHeight: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  }
`

const ImageItem = ({ fluid, ...rest }) => {
  if (!fluid) return null

  return (
    <Link to='/features' style={{height: 'inherit'}}>
      <Img
        fluid={fluid}
        {...rest}
        imgStyle={{
          objectFit: 'contain'
        }}
        style={{
          height: 'inherit',
          margin: '3px',
          filter: 'drop-shadow(0px 0px 3px rgba(0,0,0,0.3))'
        }}
      />
    </Link>
  )
}

const FeaturesCaroussel = props => {
  const data = useStaticQuery(query)
  const images = data.allFile.nodes

  const compare2ImgPath = (a,b) => a.slice(-5)[0] > b.slice(-5)[0] ? 1 : -1
  images.sort((a, b) => (compare2ImgPath(a.relativePath, b.relativePath)))

  return (
    <Swiper
      className="swiperContainer"
      navigation
      pagination
      loop
      swiperOptions={{
        slidesPerView: 1,
        disableScroll: false,
        // auto: 3000,
        // speed: 400,
        breakpoints: {
          740: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          1152: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1490: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          2024: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
        },
      }}
    >
      {images.map((image, index) => (
        <Slide
          key={index}
          style={{
            height: '300px',
            textAlign: 'center',
            width: 'auto',
          }}
        >
          <ImageItem fluid={image.childImageSharp.fluid} />
        </Slide>
      ))}
    </Swiper>
  )
}

export default FeaturesCaroussel
